<template>
  <path
    d="M21 3.00018H3C1.9 3.00018 1 3.90018 1 5.00018V19.0002C1 20.1002 1.9 21.0002 3 21.0002H21C22.1 21.0002 23 20.1002 23 19.0002V5.00018C23 3.90018 22.1 3.00018 21 3.00018ZM20 19.0002H4C3.45 19.0002 3 18.5502 3 18.0002V17.0002C3 16.4502 3.45 16.0002 4 16.0002H20C20.55 16.0002 21 16.4502 21 17.0002V18.0002C21 18.5502 20.55 19.0002 20 19.0002Z"
  />
</template>
